import { IconProps, List } from 'grommet-icons';

export const ListIcon: React.FC<IconProps> = (props) => <List size="24px" color="brand" {...props} />;
